<template>
  <div v-if="hasChapters" class="chapters-section" data-testid="chapters-section">
    <ul class="chapters-section__list">
      <li
        v-for="(chapter, index) in chapters"
        :key="index"
        class="chapters-section__item group"
        :class="{ 'chapters-section__item--active': isActiveChapter(chapter) }"
        data-testid="chapters-section-item"
      >
        <button type="button" class="chapters-section__button" @click="seekToChapter(chapter)">
          <span class="chapters-section__timestamp">{{ formatTimeCode(chapter.timecode) }}</span>
          <span class="chapters-section__title">{{ chapter.title }}</span>
        </button>
        <ButtonClipboard v-bind="getChapterShareConfig(chapter)" class="flex-shrink-0 mr-4" hidden-until-parent-hover data-testid="chapters-section-share" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useChapters } from '@/modules/viewer/composables/useChapters';
import ButtonClipboard from '@/modules/viewer/components/meta_buttons/ButtonClipboard.vue';

const { hasChapters, chapters, isActiveChapter, formatTimeCode, seekToChapter, getChapterShareConfig } = useChapters();
</script>

<style scoped>
.chapters-section {
  @apply flex flex-col;
}

.chapters-section__list {
  @apply flex flex-col;
  list-style: none;
  margin: 0;
  padding: 0;
}

.chapters-section__item {
  @apply flex items-center gap-2 rounded-lg hover:bg-zinc-50 dark:hover:bg-zinc-700/50 transition-colors border-b border-zinc-100 dark:border-zinc-700/50 last:border-b-0;
}

.chapters-section__item--active {
  @apply bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30;
}

.chapters-section__item--active .chapters-section__timestamp {
  @apply text-blue-600 dark:text-blue-400;
}

.chapters-section__item--active .chapters-section__title {
  @apply text-blue-700 dark:text-blue-300;
}

.chapters-section__button {
  @apply flex items-start gap-4 flex-grow text-left min-w-0 px-3 py-3;
}

.chapters-section__timestamp {
  @apply flex-shrink-0 text-sm font-medium text-zinc-500 dark:text-zinc-400 bg-zinc-100 dark:bg-zinc-600 px-2 py-1 rounded mt-0.5;
}

.chapters-section__title {
  @apply text-base text-zinc-800 dark:text-zinc-200 leading-snug;
}
</style>
